import styled from "styled-components";
import {HeaderArenasStyle} from "../../../../../themes/architecture/sections/theme-layout.interface";

interface HomepageHeaderArenaSkeletonDefaultBoxProps {
    isLoading: boolean;
    tilesSize: HeaderArenasStyle.BigTiles | HeaderArenasStyle.SmallTiles;
}

export const HomepageHeaderArenaSkeletonDefaultBox = styled.div<HomepageHeaderArenaSkeletonDefaultBoxProps>`

    display: ${({isLoading}) => isLoading ? "block" : "none"};

    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    &::before {
        position: absolute;
        content: "";
        top: ${({tilesSize}) => tilesSize === HeaderArenasStyle.BigTiles ? "4rem" : "2rem"};
        left: ${({tilesSize}) => tilesSize === HeaderArenasStyle.BigTiles ? "2rem" : "1rem"};
        right: ${({tilesSize}) => tilesSize === HeaderArenasStyle.BigTiles ? "2rem" : "1rem"};
        bottom: ${({tilesSize}) => tilesSize === HeaderArenasStyle.BigTiles ? "3rem" : "1rem"};
        background: radial-gradient(rgba(255, 255, 255, 0.25), rgba(255, 255, 255, 0.1));
        border-radius: ${({tilesSize}) => tilesSize === HeaderArenasStyle.BigTiles ? "40%" : "43%"};
    
        animation: LoadingAnimation linear 1s 5;
    }

    @keyframes LoadingAnimation {
        0% {
            opacity: 1;
        }
        50% {
            opacity: 0.5;
        }
        100% {
            opacity: 1;
        }
    }
`;
